import { Component, OnDestroy, OnInit, AfterViewInit, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DashboardService } from '../../../shared/services/dashboard.service';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';


@Component({
  selector: 'flow-tracking-chart',
  templateUrl: './flow-tracking-chart.component.html',
  styleUrls: ['./flow-tracking-chart.component.scss']
})
export class FlowTrackingChartComponent implements OnInit {

  public action: string = '';
  public chart_range = '7';
  public data: any = []
  public chart_data: any[] = [];
  public chart_summary = '';
  private chart: am4charts.XYChart | null = null;

  constructor(
    private dashboardService: DashboardService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private zone: NgZone
  ) { }

  ngOnInit(): void {
    this.getChartData();
  }

  getbody() {
    let body = {
      "action": this.action,
      "user_id": [localStorage.getItem('user')]
    }
    return body;
  }

  getChartData(){
    this.action = 'getFlowTrackingChart';
    this.dashboardService.httpPost(this.getbody()).subscribe((res: any) => {
      this.data = res.data;
      this.chart_data = this.data.last_7_days;
      this.updateChartData();
    })

  }
  
  onChartRangeChange() {
    this.setChartDataForRange(this.chart_range);
    this.updateChartData();
  }

  setChartDataForRange(range: string) {
    if (range === '30') {
      this.chart_data = this.data.last_30_days;
      this.chart_summary = 'Sample daily volumes for the last 30 days.';
      return;
    }

    if (range === 'month') {
      this.chart_data = this.data.this_month;
      this.chart_summary = 'Sample daily volumes for this month so far.';
      return;
    }

    this.chart_data = this.data.last_7_days;
    this.chart_summary = 'Sample daily volumes for the last 7 days: Monday 1200, Tuesday 1850, Wednesday 940, Thursday 2100, Friday 1600, Saturday 1320, Sunday 1780.';
  }

  renderDummyChart() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.zone.runOutsideAngular(() => {
      am4core.useTheme(am4themes_animated);

      const chart = am4core.create('flowTrackingVolumeChart', am4charts.XYChart);
      chart.paddingRight = 20;
      chart.data = this.chart_data;

      const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'day';
      categoryAxis.title.text = 'Day';
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;

      const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = 'Volume (litre)';
      valueAxis.min = 0;

      const series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.categoryX = 'day';
      series.dataFields.valueY = 'volume';
      series.name = 'Received volume';
      series.columns.template.tooltipText = '{categoryX}: [bold]{valueY} litre[/]';
      series.columns.template.fillOpacity = 0.9;
      series.columns.template.strokeWidth = 0;
      series.columns.template.fill = am4core.color('#073c5c');

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineY.opacity = 0;

      this.chart = chart;
    });
  }

  updateChartData() {
    if (!this.chart) {
      return;
    }

    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.data = this.chart_data;
      }
    });
  }

  ngAfterViewInit(): void {
    this.renderDummyChart();
  }

  ngOnDestroy(): void {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
    });
  }
}
